// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

import Rails from "@rails/ujs";

import * as ActiveStorage from "@rails/activestorage";

import "lazyload";
import "bootstrap";

window.jQuery = window.jQuery || jQuery;
window.$ = window.$ || $;

import "bootstrap-datepicker";
import "bootstrap-datepicker/dist/locales/bootstrap-datepicker.pt-BR.min.js";

import "./ui";
import "./modal";
import "../auto_hide_header";
import "../animated_document_title";

import "channels";

import "./conferences";
import "./calls";

const loadPackOnce = (() => {
  const cache = {};

  return (key, loader) => {
    if (!cache[key]) {
      cache[key] = loader();
    }

    return cache[key];
  };
})();

const loadFormsPack = () => loadPackOnce("forms", () => import("./forms"));
const loadMessagesPack = () => loadPackOnce("messages", () => import("./messages"));
const loadFlashMessagePack = () => loadPackOnce("flash_message", () => import("./flash_message"));

if (document.querySelector(".alert-notice")) {
  loadFlashMessagePack();
}

const messagesActivationSelector = [
  "[data-load-messages]",
  "#messageModal",
  ".open-chat",
  ".open-chat-popup",
  ".chat-btn-send",
  "[data-message-contact-list-root]",
  "[data-box-all-messages]"
].join(",");

if (document.querySelector(messagesActivationSelector)) {
  loadMessagesPack();
}

const lazyLoadMessagesOnClick = (event) => {
  if (!event.target || !event.target.closest) {
    return;
  }

  if (event.target.closest(messagesActivationSelector)) {
    loadMessagesPack();
    document.removeEventListener("click", lazyLoadMessagesOnClick, true);
  }
};

document.addEventListener("click", lazyLoadMessagesOnClick, true);

const formsBootstrapSelector = [
  "[data-mask]",
  "[data-cep]",
  "[data-cpf]",
  "[data-cnpj]",
  "[data-type-cpf]",
  "[data-type-cnpj]",
  ".reset-input-on-checked"
].join(",");

if (document.querySelector(formsBootstrapSelector)) {
  loadFormsPack();
}

const lazyLoadFormsOnInteraction = (event) => {
  if (!event.target || !event.target.closest) {
    return;
  }

  if (event.target.closest("form")) {
    loadFormsPack();
    document.removeEventListener("focusin", lazyLoadFormsOnInteraction, true);
    document.removeEventListener("change", lazyLoadFormsOnInteraction, true);
    document.removeEventListener("click", lazyLoadFormsOnInteraction, true);
  }
};

document.addEventListener("focusin", lazyLoadFormsOnInteraction, true);
document.addEventListener("change", lazyLoadFormsOnInteraction, true);
document.addEventListener("click", lazyLoadFormsOnInteraction, true);

if (document.querySelector("#tabs")) {
  import("./tabs");
}

if (document.querySelector("#occupation_slug")) {
  import("./specialties");
}

if (
  document.querySelector("#companiesRoiSimulator") ||
  document.querySelector("#companiesInvestmentCallout")
) {
  import("../companies_landing_roi");
}

if (
  document.querySelector(".home-social-proof") ||
  document.querySelector(".companies-social-proof")
) {
  import("../home_social_proof_countup");
}

if (
  document.body.classList.contains("home-index") ||
  document.body.classList.contains("professionals-index") ||
  document.body.classList.contains("professionals-index_by_occupation") ||
  document.body.classList.contains("companies-show")
) {
  import("../scroll_reveal");
}

if (document.querySelector(".js-home-depoimentos")) {
  import("../home_testimonials_reveal");
}

if (
  document.querySelector("#btn-call") ||
  document.querySelector("#securityCodeModal") ||
  document.querySelector("#callModal")
) {
  import("./calls");
}

if (
  document.querySelector(".js-pix-recharge-form") ||
  document.querySelector("#pix-modal")
) {
  import("../pix_wallet_recharge");
}

if (document.querySelector(".occupation-categories")) {
  import("../occupation_categories_swiper");
}

if (document.querySelector("#mainCarousel")) {
  import("./home_carousel");
}

Rails.start();
ActiveStorage.start();

window.urlify = function (text) {
  if (typeof text !== 'string') {
    return text || '';
  }

  if (text.includes("<a ")) {
    return text;
  }

  text = text.replace(/\n/g, "<br>");

  var urlRegex = /((https?:\/\/|www\.)[^\s<]+)/g;
  var fileExtensions = /\.(pdf|jpg|jpeg|png|gif|bmp|docx|doc|xlsx|xls|ppt|pptx|zip|rar)$/i;

  return text.replace(urlRegex, function (url) {
    var formattedUrl = url.startsWith("www.") ? "http://" + url : url;
    var newTab = "";
    var trailingPunctuation = /[.,!?;]$/;
    var urlWithoutPunctuation = url.replace(trailingPunctuation, '');
    var punctuation = trailingPunctuation.test(url) ? url.slice(-1) : '';

    try {
      var urlObject = new URL(formattedUrl);

      if (fileExtensions.test(urlObject.pathname) || urlObject.hostname !== window.location.hostname) {
        newTab = ' target="_blank"';
      }

      return `<a href="${formattedUrl}"${newTab}>${urlWithoutPunctuation}</a>${punctuation}`;
    } catch (e) {
      return url;
    }
  });
};

// SCHEDULE
$(document).ready(function() {

  function schedule ($scheduleModal) {
    if (!$scheduleModal.length) {
      return;
    }

    const scheduleRoot = $scheduleModal[0];
    if (!scheduleRoot || scheduleRoot.dataset.scheduleInitialized === "true") {
      return;
    }
    scheduleRoot.dataset.scheduleInitialized = "true";

    let scheduleDateInterval;
    const today = new Date();
    const tomorrow = new Date();

    tomorrow.setDate(today.getDate() + 1);

    const day = String(tomorrow.getDate()).padStart(2, '0');
    const month = String(tomorrow.getMonth() + 1).padStart(2, '0');
    const year = tomorrow.getFullYear();
    const formattedDate = day + '/' + month + '/' + year;

    const $scheduleDate = $scheduleModal.find("[data-schedule-date]");
    const $expectedMinutes = $scheduleModal.find('select[name="expected_minutes"]');
    const $startTime = $scheduleModal.find('select[name="start_time"]');
    const $submitButton = $scheduleModal.find('button.js-schedule-submit');
    const $scheduleForm = $scheduleModal.find('form').first();
    const $startAtInput = $scheduleModal.find('input[name="start_at"]');
    const $startTimeInput = $scheduleModal.find('select[name="start_time"]');
    const availableDates = $scheduleModal.data('available-days');
    const isModal = $scheduleModal.hasClass("modal");

    let availableDaysWithTimes = {};
    let selectedDate = null;

    if (availableDates) {
      if (typeof availableDates === "object") {
        availableDaysWithTimes = availableDates;
      } else if (typeof availableDates === "string") {
        try {
          let jsonString = availableDates.replace(/"=>/g, '":').replace(/(\w+)=>/g, '"$1":');
          availableDaysWithTimes = JSON.parse(jsonString);
        } catch (e) {
          console.error("Erro ao processar availableDates:", e);
        }
      }
    }

    const hasAvailabilityGrid = Object.keys(availableDaysWithTimes).length > 0;
    const minimumLeadMinutesRaw = scheduleRoot ? parseInt(scheduleRoot.dataset.schedulingMinimumLeadMinutes, 10) : NaN;
    const minimumLeadMinutes = Number.isFinite(minimumLeadMinutesRaw) && minimumLeadMinutesRaw > 0 ? minimumLeadMinutesRaw : 15;
    let datepickerObserver;

    function roundScheduleMoney2 (n) {
      return Math.round(Number(n) * 100) / 100;
    }

    function updateScheduleCtaLabel () {
      if (!scheduleRoot || !$scheduleModal.find('.js-schedule-cta-label').length) {
        return;
      }

      const base = scheduleRoot.dataset.scheduleBaseLabel;

      if (!base) {
        return;
      }

      const eligible = scheduleRoot.dataset.scheduleCortesiaEligible === 'true';
      const rawMinutes = $expectedMinutes.val();
      const minutes = parseInt(rawMinutes, 10);
      const hasDuration = rawMinutes !== '' && !Number.isNaN(minutes);

      // 1.ª vez com o profissional e duração > 15 min: texto da promoção no botão da agenda.
      let showCortesia = false;
      if (eligible && Number.isFinite(minutes) && minutes > 15) {
        showCortesia = true;
      }

      const text = base + (showCortesia ? ' (15 min grátis)' : '');

      $scheduleModal.find('.js-schedule-cta-label').text(text);
    }

    function syncStartAtFromFields () {
      const scheduleDate = $scheduleDate.datepicker("getDate");
      const scheduleDateStartTime = $startTime.val();

      if (scheduleDate && scheduleDateStartTime) {
        const scheduleDateWithHour = new Date(scheduleDate);
        const [hours, minutes] = scheduleDateStartTime.split(":").map(Number);

        scheduleDateWithHour.setHours(hours);
        scheduleDateWithHour.setMinutes(minutes);
        $startAtInput.val(scheduleDateWithHour);
      } else {
        $startAtInput.val("");
      }
    }

    function isDateAvailable(date) {
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const formattedDate = `${day}/${month}/${year}`;

      return Object.keys(availableDaysWithTimes).includes(formattedDate) ? { enabled: true, classes: 'available-date' } : { enabled: false, classes: 'disabled-date' };
    }

    function filterSelectOptions(maxDuration) {
      $expectedMinutes.find("option").each(function () {
        const optionValue = parseInt($(this).val(), 10);

        if (isNaN(optionValue)) {
          $(this).show();
        } else if (optionValue <= maxDuration) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      $expectedMinutes.val("");
      updateScheduleCtaLabel();
    }

    function generateAllTimes() {
      return [
        "00:00", "00:15", "00:30", "00:45",
        "01:00", "01:15", "01:30", "01:45",
        "02:00", "02:15", "02:30", "02:45",
        "03:00", "03:15", "03:30", "03:45",
        "04:00", "04:15", "04:30", "04:45",
        "05:00", "05:15", "05:30", "05:45",
        "06:00", "06:15", "06:30", "06:45",
        "07:00", "07:15", "07:30", "07:45",
        "08:00", "08:15", "08:30", "08:45",
        "09:00", "09:15", "09:30", "09:45",
        "10:00", "10:15", "10:30", "10:45",
        "11:00", "11:15", "11:30", "11:45",
        "12:00", "12:15", "12:30", "12:45",
        "13:00", "13:15", "13:30", "13:45",
        "14:00", "14:15", "14:30", "14:45",
        "15:00", "15:15", "15:30", "15:45",
        "16:00", "16:15", "16:30", "16:45",
        "17:00", "17:15", "17:30", "17:45",
        "18:00", "18:15", "18:30", "18:45",
        "19:00", "19:15", "19:30", "19:45",
        "20:00", "20:15", "20:30", "20:45",
        "21:00", "21:15", "21:30", "21:45",
        "22:00", "22:15", "22:30", "22:45",
        "23:00", "23:15", "23:30", "23:45"
      ];
    }

    function toggleStartTimeOptions(duration) {
      $startTime.empty();

      let availableTimes = new Set();

      function addTimesInRange(startHour, startMinute, endHour, endMinute) {
        const startDate = new Date(0, 0, 0, startHour, startMinute);
        const endDate = new Date(0, 0, 0, endHour, endMinute);

        startDate.setMinutes(Math.ceil(startDate.getMinutes() / 15) * 15);

        while (true) {
          const endTime = new Date(startDate.getTime() + duration * 60000);
          const formattedStart = `${String(startDate.getHours()).padStart(2, '0')}:${String(startDate.getMinutes()).padStart(2, '0')}`;

          if (availableDaysWithTimes[selectedDate]) {
            if (endTime.getTime() <= endDate.getTime()) {
              availableTimes.add(formattedStart);
            } else {
              break;
            }
          } else {
            if (endTime.getHours() === 0 && endTime.getMinutes() === 0) {
              availableTimes.add(formattedStart);
            } else if (endTime.getTime() <= endDate.getTime()) {
              availableTimes.add(formattedStart);
            } else {
              break;
            }
          }

          startDate.setMinutes(startDate.getMinutes() + 15);
        }
      }

      function isToday(date) {
        const today = new Date();

        return date.getDate() === today.getDate() &&
               date.getMonth() === today.getMonth() &&
               date.getFullYear() === today.getFullYear();
      }

      const selectedDateParts = selectedDate.split('/');
      const currentDate = new Date(selectedDateParts[2], selectedDateParts[1] - 1, selectedDateParts[0]); // Formato correto para Date

      let _availableDaysWithTimes;

      if (isToday(currentDate)) {
        const now = new Date();
        const availableStartDate = new Date(now.getTime() + minimumLeadMinutes * 60 * 1000);
        // Arredonda para o próximo slot de 15 minutos.
        const roundedAvailableStartDate = new Date(availableStartDate);
        const roundedMinutes = Math.ceil(roundedAvailableStartDate.getMinutes() / 15) * 15;
        roundedAvailableStartDate.setMinutes(roundedMinutes, 0, 0);

        const earliestAvailableMinutes = (roundedAvailableStartDate.getHours() * 60) + roundedAvailableStartDate.getMinutes();
        const sourceRanges = availableDaysWithTimes[selectedDate] || ['00:00 - 23:45'];
        const filteredRanges = [];

        sourceRanges.forEach((timeRange) => {
          const [start, end] = timeRange.split(" - ");
          const [startHour, startMinute] = start.split(":").map(Number);
          const [endHour, endMinute] = end.split(":").map(Number);
          const rangeStartMinutes = (startHour * 60) + startMinute;
          const rangeEndMinutes = (endHour * 60) + endMinute;

          if (rangeEndMinutes <= earliestAvailableMinutes) {
            return;
          }

          const clampedStartMinutes = Math.max(rangeStartMinutes, earliestAvailableMinutes);
          const clampedStartHour = Math.floor(clampedStartMinutes / 60);
          const clampedStartMinute = clampedStartMinutes % 60;
          const formattedStart = `${String(clampedStartHour).padStart(2, '0')}:${String(clampedStartMinute).padStart(2, '0')}`;
          const formattedEnd = `${String(endHour).padStart(2, '0')}:${String(endMinute).padStart(2, '0')}`;

          filteredRanges.push(`${formattedStart} - ${formattedEnd}`);
        });

        _availableDaysWithTimes = filteredRanges;
      } else {
        _availableDaysWithTimes = availableDaysWithTimes[selectedDate] || ['00:00 - 23:45'];
      }

      _availableDaysWithTimes.forEach(timeRange => {
        const [start, end] = timeRange.split(" - ");
        let [startHour, startMinute] = start.split(":").map(Number);
        const [endHour, endMinute] = end.split(":").map(Number);

        addTimesInRange(startHour, startMinute, endHour, endMinute);
      });

      let optionsHtml = Array.from(availableTimes).map(time => `<option value="${time}">${time}</option>`).join("");
      const hasOptions = optionsHtml.length > 0;

      $startTime.append('<option value=""></option>').append(optionsHtml).prop('disabled', !hasOptions).val("");
    }

    function validateForm() {
      const durationSelected = $expectedMinutes.val() !== "";
      const startTimeSelected = $startTime.val() !== "";

      $submitButton.prop("disabled", !(durationSelected && startTimeSelected));
    }

    function getLastAvailableDate() {
      const dates = Object.keys(availableDaysWithTimes);

      if (dates.length === 0) return null;

      const formattedDates = dates.map(date => {
        const [day, month, year] = date.split('/');

        return new Date(`${year}-${month}-${day}T23:59:59`);
      });

      return new Date(Math.max.apply(null, formattedDates));
    }

    let now = new Date();

    now.setMinutes(now.getMinutes() + minimumLeadMinutes);

    let datepickerConfig = {
      format: "dd/mm/yyyy",
      startDate: now,
      language: "pt-BR"
    };

    function restoreDatepickerDayContent() {
      $scheduleDate.find('.datepicker td.day, .datepicker td.old, .datepicker td.new').each(function () {
        // data-date é meia-noite UTC. getDate() no fuso do Brasil volta um dia e desloca a grade.
        const epoch = parseInt(this.getAttribute('data-date'), 10);
        if (!Number.isFinite(epoch)) {
          return;
        }

        const date = new Date(epoch);
        if (Number.isNaN(date.getTime())) {
          return;
        }

        const day = String(date.getUTCDate());
        if ((this.textContent || '').trim() === day) {
          return;
        }

        this.textContent = day;
      });
    }

    if (hasAvailabilityGrid) {
      datepickerConfig.endDate = getLastAvailableDate();

      datepickerConfig.beforeShowDay = (date) => {
        const availability = isDateAvailable(date);

        // Keep explicit day content to avoid cells being rendered without numerals.
        return {
          enabled: availability.enabled,
          classes: availability.classes,
          content: String(date.getDate())
        };
      }
    }

    $scheduleDate.datepicker(datepickerConfig);
    restoreDatepickerDayContent();

    if (typeof MutationObserver !== "undefined") {
      datepickerObserver = new MutationObserver(() => {
        restoreDatepickerDayContent();
      });

      datepickerObserver.observe($scheduleDate[0], {
        subtree: true,
        childList: true,
        characterData: true
      });
    }

    $scheduleDate.on("changeDate", function (e) {
      if (!e.date) return;

      const date = e.date;
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();

      selectedDate = `${day}/${month}/${year}`;

      $expectedMinutes.prop('disabled', false).val("");
      $startTime.prop('disabled', true).val("");
      $submitButton.prop("disabled", true);

      if (availableDaysWithTimes[selectedDate]) {
        let maxDuration = 0;

        availableDaysWithTimes[selectedDate].forEach(timeRange => {
          const [start, end] = timeRange.split(" - ");
          const [startHour, startMinute] = start.split(":").map(Number);
          const [endHour, endMinute] = end.split(":").map(Number);
          const startDate = new Date(0, 0, 0, startHour, startMinute);
          const endDate = new Date(0, 0, 0, endHour, endMinute);
          const duration = (endDate - startDate) / (1000 * 60);

          if (duration > maxDuration) {
            maxDuration = duration;
          }
        });

        filterSelectOptions(maxDuration);
      }

      if (!isModal) {
        syncStartAtFromFields();
      }

      updateScheduleCtaLabel();
    });

    $expectedMinutes.on("change", function () {
      const duration = parseInt($(this).val(), 10);

      if (hasAvailabilityGrid) {
        if (duration && selectedDate) {
          toggleStartTimeOptions(duration);
        } else {
          $startTime.prop('disabled', true).val("");
        }
      } else {
        toggleStartTimeOptions(duration);
        $startTime.prop('disabled', false).val("");
      }

      validateForm();
      updateScheduleCtaLabel();
      if (!isModal) {
        syncStartAtFromFields();
      }
    });

    $startTime.on("change", function () {
      validateForm();
      if (!isModal) {
        syncStartAtFromFields();
      }
    });

    if ($scheduleForm.length) {
      $scheduleForm.on("keydown", function (e) {
        if (e.key === "Enter" && e.target.tagName !== "TEXTAREA") {
          e.preventDefault();
        }
      });
    }

    function submitScheduleForm () {
      const formEl = $scheduleForm[0];

      if (formEl && typeof formEl.requestSubmit === "function") {
        formEl.requestSubmit();
      } else if (formEl) {
        formEl.submit();
      }
    }

    function openCvvModalForSchedule() {
      const $cvvHidden = $scheduleForm.find('input[name="securityCode"]');
      if (!$cvvHidden.length) {
        return false;
      }

      $cvvHidden.val("");
      window.__scheduleCvvPending = {
        $form: $scheduleForm,
        submit: submitScheduleForm
      };

      $("#schedule-cvv-input").val("");

      if (typeof $ !== "undefined" && $.fn.modal) {
        $("#scheduleCvvModal").modal("show");
        return true;
      }

      return false;
    }

    function openPaymentChoiceModalForSchedule(shortfall, options) {
      const $choiceModal = $("#schedulePaymentRequiredModal");
      if (!$choiceModal.length || !(typeof $ !== "undefined" && $.fn.modal)) {
        return false;
      }

      const opts = options || {};
      window.__schedulePaymentMethodPending = {
        shortfall: shortfall,
        $form: $scheduleForm,
        openCvv: openCvvModalForSchedule,
        hasCreditCard: !!opts.hasCreditCard,
        canUsePix: !!opts.canUsePix,
        balance: Number.isFinite(opts.balance) ? opts.balance : 0,
      };
      $choiceModal.modal("show");
      return true;
    }

    $submitButton.on("click", function () {
      if ($(this).prop("disabled")) {
        return;
      }

      const requiresAuth = scheduleRoot && scheduleRoot.dataset.scheduleRequiresAuth === "true";
      if (requiresAuth) {
        const authModalTarget = scheduleRoot.dataset.authModalTarget || "#newSessionModal";
        if (typeof $ !== "undefined" && $.fn.modal && $(authModalTarget).length) {
          $(authModalTarget).modal("show");
        }
        return;
      }

      syncStartAtFromFields();

      if (!$scheduleDate.datepicker("getDate")) {
        alert("Por favor, selecione uma data para o agendamento.");

        return;
      }

      if ($expectedMinutes.val() === "" || $startTime.val() === "") {
        return;
      }

      const pixReady = scheduleRoot.dataset.pixRecharge === "true";
      const balance = parseFloat(scheduleRoot.dataset.walletBalance, 10);
      const balanceSafe = Number.isFinite(balance) ? balance : 0;

      const $opt = $expectedMinutes.find("option:selected");
      const rawPrice = $opt.data("price");
      let totalCost =
        rawPrice === undefined || rawPrice === null || rawPrice === ""
          ? 0
          : parseFloat(rawPrice);
      if (!Number.isFinite(totalCost)) totalCost = 0;

      const shortfall = roundScheduleMoney2(Math.max(0, totalCost - balanceSafe));

      const creditCardCheckout = scheduleRoot.dataset.checkoutCreditCard === "true";
      const hasCreditCard = scheduleRoot.dataset.hasCreditCard === "true";
      const hasShortfall = shortfall >= 0.01;
      const canUsePix = hasShortfall && pixReady;
      const canUseCreditCard = hasShortfall && creditCardCheckout && hasCreditCard;

      if (hasShortfall && canUsePix && creditCardCheckout) {
        const opened = openPaymentChoiceModalForSchedule(shortfall, {
          hasCreditCard: hasCreditCard,
          canUsePix: canUsePix,
          balance: balanceSafe,
        });
        if (opened) {
          return;
        }
      }

      if (canUsePix) {
        if (
          !window.pixRecharge ||
          typeof window.pixRecharge.generateWalletRechargePix !== "function"
        ) {
          window.alert(
            "Recarga via PIX indisponível. Atualize a página ou tente novamente."
          );

          return;
        }

        const formEl = $scheduleForm[0];

        window.__pixSuccessCallback = function () {
          setTimeout(function () {
            if (formEl && typeof formEl.requestSubmit === "function") {
              formEl.requestSubmit();
            } else if (formEl) {
              formEl.submit();
            }
          }, 1000);
        };

        window.pixRecharge.generateWalletRechargePix(shortfall, {
          context: "shortfall",
        });

        return;
      }

      if (canUseCreditCard) {
        const opened = openCvvModalForSchedule();
        if (opened) {
          return;
        }
      }

      if (hasShortfall && !canUsePix && !canUseCreditCard && creditCardCheckout) {
        if (typeof $ !== "undefined" && $.fn.modal && $("#schedulePaymentRequiredModal").length) {
          window.__schedulePaymentMethodPending = {
            shortfall: shortfall,
            $form: $scheduleForm,
            openCvv: openCvvModalForSchedule,
            hasCreditCard: hasCreditCard,
            canUsePix: false,
            balance: balanceSafe,
          };
          $("#schedulePaymentRequiredModal").modal("show");
          return;
        }
      }

      submitScheduleForm();
    });

    if (isModal) {
      $scheduleModal.on("shown.bs.modal", function () {
        restoreDatepickerDayContent();

        scheduleDateInterval = setInterval(() => {
          const scheduleDate = $scheduleDate.datepicker("getDate");

          if (scheduleDate) {
            const scheduleDateWithHour = new Date(scheduleDate);
            const scheduleDateStartTime = $startTimeInput.val();

            if (scheduleDateStartTime) {
              const [hours, minutes] = scheduleDateStartTime.split(":").map(Number);

              scheduleDateWithHour.setHours(hours);
              scheduleDateWithHour.setMinutes(minutes);
            }

            $startAtInput.val(scheduleDateWithHour);
          } else {
            $startAtInput.val("");
          }
        }, 300);
      });

      $scheduleModal.on("hidden.bs.modal", function () {
        clearInterval(scheduleDateInterval);
        if (datepickerObserver) {
          datepickerObserver.disconnect();
          datepickerObserver = null;
        }
        $scheduleDate.datepicker("clearDates");
        $expectedMinutes.val("").prop('disabled', true);
        $startTime.val("").prop('disabled', true);
        $submitButton.prop("disabled", true);
        updateScheduleCtaLabel();
        $scheduleForm.find('input[name="securityCode"]').val("");
      });
    }

    $scheduleModal.on("submit", function (e) {
      if (!$scheduleDate.datepicker("getDate")) {
        e.preventDefault();
        alert("Por favor, selecione uma data para o agendamento.");
      }
    });

    updateScheduleCtaLabel();
  }

  schedule($("#scheduleModal"));
  schedule($("#profileScheduleInline"));

  $(document).on("click", "#schedule-cvv-confirm", function () {
    const $input = $("#schedule-cvv-input");
    const v = $.trim($input.val() || "");

    if (!v) {
      window.alert("Informe o código de segurança (CVV) do cartão.");

      return;
    }

    const pending = window.__scheduleCvvPending;

    if (!pending || !pending.$form || !pending.$form.length) {
      $("#scheduleCvvModal").modal("hide");

      return;
    }

    pending.$form.find('input[name="securityCode"]').val(v);
    $("#scheduleCvvModal").modal("hide");
    $input.val("");

    if (typeof pending.submit === "function") {
      pending.submit();
    }

    window.__scheduleCvvPending = null;
  });

  $(document).on("hidden.bs.modal", "#scheduleCvvModal", function () {
    window.__scheduleCvvPending = null;
    $("#schedule-cvv-input").val("");
  });

  $(document).on("click", ".js-schedule-payment-required-option", function (e) {
    e.preventDefault();
    const method = ($(this).data("method") || "").toString();
    const pending = window.__schedulePaymentMethodPending;

    if (!pending || !pending.$form || !pending.$form.length) {
      $("#schedulePaymentRequiredModal").modal("hide");
      return;
    }

    if (method === "pix") {
      if (!pending.canUsePix) {
        window.alert("Pagamento via PIX indisponível para esta conta.");
        return;
      }

      if (
        !window.pixRecharge ||
        typeof window.pixRecharge.generateWalletRechargePix !== "function"
      ) {
        window.alert("Recarga via PIX indisponível. Atualize a página ou tente novamente.");
        return;
      }

      const formEl = pending.$form[0];
      window.__pixSuccessCallback = function () {
        setTimeout(function () {
          if (formEl && typeof formEl.requestSubmit === "function") {
            formEl.requestSubmit();
          } else if (formEl) {
            formEl.submit();
          }
        }, 1000);
      };

      $("#schedulePaymentRequiredModal").modal("hide");
      window.pixRecharge.generateWalletRechargePix(pending.shortfall, { context: "shortfall" });
      window.__schedulePaymentMethodPending = null;
      return;
    }

    if (method === "credit_card") {
      $("#schedulePaymentRequiredModal").modal("hide");
      if (pending.hasCreditCard && typeof pending.openCvv === "function") {
        pending.openCvv();
      } else {
        const $required = $("#schedulePaymentRequiredModal");
        const creditCardUrl = $required.data("creditCardUrl");
        if (creditCardUrl) {
          window.location.href = creditCardUrl;
        }
      }
      window.__schedulePaymentMethodPending = null;
    }
  });

  $(document).on("hidden.bs.modal", "#schedulePaymentRequiredModal", function () {
    window.__schedulePaymentMethodPending = null;
  });

  $(document).on("show.bs.modal", "#schedulePaymentRequiredModal", function () {
    const pending = window.__schedulePaymentMethodPending || {};
    const $modal = $("#schedulePaymentRequiredModal");
    const $pixBtn = $modal.find('.js-schedule-payment-required-option[data-method="pix"]');
    const $cardBtn = $modal.find('.js-schedule-payment-required-option[data-method="credit_card"]');
    const $message = $modal.find(".js-schedule-payment-required-message");

    if ($pixBtn.length) {
      $pixBtn.toggleClass("d-none", !pending.canUsePix);
    }

    if ($cardBtn.length) {
      $cardBtn.text(pending.hasCreditCard ? "Pagar com cartão" : "Cadastrar cartão");
    }

    if ($message.length) {
      const balance = Number(pending.balance || 0);
      const msg = balance > 0.009
        ? "Seu saldo não cobre esta duração. Escolha como deseja pagar a diferença."
        : "Esta duração não pode ser coberta com o saldo atual da carteira. Escolha como deseja pagar.";
      $message.text(msg);
    }
  });
});

window.playAudio = function ($element) {
  var audio = $($element)[0];

  audio
    .play()
    .then(() => {
      // console.log("Áudio reproduzido com sucesso!");
    })
    .catch((error) => {
      // console.error("Erro ao reproduzir áudio:", error);
    });
};

window.stopAudio = function ($element) {
  var audio = $($element)[0];

  audio.currentTime = 0;

  audio.pause();
};

window.addToast = function (message, icon) {
  var iconHTML = "";

  if ($("#liveToast").length) {
    $("#liveToast").remove();
  }

  if (icon) {
    iconHTML = `<i class="fas ${icon} mr-2 text-white"></i>`;
  }

  $("body").append(`
    <div id="liveToast" class="position-fixed p-3" style="z-index: 99999999; left: 0; bottom: 0;">
      <div class="toast bg-dark hide" role="alert" aria-live="assertive" aria-atomic="true" data-delay="2000">
        <div class="toast-body text-white">
          ${iconHTML}
          ${message}
        </div>
      </div>
    </div>
  `);

  $("#liveToast .toast").toast("show");
};

// Fullscreen utilities
window.FullscreenUtils = {
  isFullscreen() {
    const d = document;
    return !!(d.fullscreenElement || d.webkitFullscreenElement || d.msFullscreenElement);
  },

  exitFullscreen() {
    const d = document;
    if (this.isFullscreen()) {
      (d.exitFullscreen || d.webkitExitFullscreen || d.msExitFullscreen).call(d);
    }
  }
};

$(".modal").on("shown.bs.modal", function () {
  $('img[data-original][src^="data:image/"]').lazyload();
});

// share social_buttons

$(".social-button a").on("click", function (e) {
  e.preventDefault();

  window.open(
    $(this).attr("href"),
    "sharer",
    "toolbar=0,status=0,width=548,height=325",
  );
});

/* Javascript to show and hide cookie banner using localstorage */
/* Shows the Cookie banner */
var showCookieBanner = function () {
  $('#helpcam-cookie-banner').fadeIn(function () {
    $('#helpcam-cookie-banner .alert').slideDown();
  });
};

/* Hides the Cookie banner and saves the value to localstorage */
var hideCookieBanner = function () {
  localStorage.setItem('cookieAccepted', 'yes');

  $('#helpcam-cookie-banner .alert').slideUp(function () {
    $('#helpcam-cookie-banner').fadeOut();
  });
};

/* Checks the localstorage and shows Cookie banner based on it. */
var initializeCookieBanner = function () {
  var isCookieAccepted = localStorage.getItem('cookieAccepted');

  if (isCookieAccepted === null) {
    localStorage.setItem('cookieAccepted', 'no');
    showCookieBanner();
  }

  if (isCookieAccepted === 'no') {
    showCookieBanner();
  }

  $('#helpcam-cookie-banner .btn-primary').on('click', function (event) {
    var $element = $(event.target);

    event.stopPropagation();

    hideCookieBanner();
  });
};

// COOKIE BANNER
initializeCookieBanner();

// Modais automáticos: exibir apenas UM por carregamento (config vem do admin)
function getAutoShowModalsConfig() {
  var $el = $('#admin-modals-config');
  if (!$el.length) return [];
  try {
    var arr = JSON.parse($el.text());
    return arr || [];
  } catch (e) {
    return [];
  }
}

// Mesma regra do auto-show + sininho: "pendente" = ainda não visto no período de recorrência
function adminModalDueForNotification(storedValue, recurrenceDays) {
  if (!storedValue) return true;
  if (storedValue === 'true') return true;
  var d = recurrenceDays || 7;
  var storedDate = new Date(storedValue + 'T12:00:00');
  if (isNaN(storedDate.getTime())) return true;
  var diffDays = (Date.now() - storedDate.getTime()) / (1000 * 60 * 60 * 24);
  return diffDays >= d;
}

$(function () {
  if (document.getElementById("js-open-auth-modal")) {
    var $authModal = $("#newSessionModal");
    if ($authModal.length) {
      $authModal.modal("show");
    }
    return;
  }

  var today = new Date().toLocaleDateString('pt-BR', {
    timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
  }).split('/').reverse().join('-');

  var configs = getAutoShowModalsConfig();
  for (var i = 0; i < configs.length; i++) {
    var c = configs[i];
    var $m = $('#' + c.id);
    if (!$m.length) continue;
    if (!adminModalDueForNotification(localStorage.getItem(c.key), c.recurrence_days)) continue;

    $m.modal('show');
    localStorage.setItem(c.key, today);
    return;
  }
});

// Mobile app prompt modal: auto-open + localStorage dismiss
function getMobileAppPromptConfig() {
  var $el = $('#mobile-app-prompt-config');
  if (!$el.length) return null;
  try {
    return JSON.parse($el.text()) || null;
  } catch (e) {
    return null;
  }
}

$(function () {
  if (document.getElementById("js-open-auth-modal")) return;

  var config = getMobileAppPromptConfig();
  if (!config) return;

  var sessionKey = 'mobile_app_prompt_dismissed_session';
  var forcedPrompt = !!config.forced_prompt;
  if (!forcedPrompt && window.matchMedia && !window.matchMedia('(max-width: 767.98px)').matches) return;
  if (window.sessionStorage && sessionStorage.getItem(sessionKey) === '1') return;

  var $modal = $('#mobileAppPromptModal');
  if (!$modal.length) return;
  $modal.modal('show');

  $(document).on('click', '#mobileAppPromptModal .js-mobile-app-prompt-dismiss', function () {
    if (window.sessionStorage) sessionStorage.setItem(sessionKey, '1');
  });
});

// Modais "Saiba mais" — abrir ao clicar nos links (target dinâmico do admin)
$(document).on('click', '[data-toggle="modal"][data-target^="#admin-modal-"]', function (e) {
  e.preventDefault();
  var target = $(this).data('target');
  if (target) $(target).modal('show');
});

// Sininho de notificações — lista modais configurados no admin
function getNotificationModalsConfig() {
  var $el = $('#admin-modals-config');
  if (!$el.length) return [];
  try {
    var arr = JSON.parse($el.text());
    return (arr || []).map(function (c) {
      return {
        id: c.id,
        key: c.key,
        label: c.label,
        icon: c.icon || 'fa-bell',
        recurrence_days: c.recurrence_days
      };
    });
  } catch (e) {
    return [];
  }
}

function buildNotificationList() {
  var listItems = [];
  var pendingCount = 0;
  var isProfessional = document.body.getAttribute('data-user-role') === 'professional' || document.body.getAttribute('data-is-professional') === 'true';
  var configs = getNotificationModalsConfig();

  configs.forEach(function (config) {
    var wasShown = localStorage.getItem(config.key);
    var $modal = $('#' + config.id);
    var eligibleInBell = $modal.length && (isProfessional || !!wasShown);
    if (!eligibleInBell) return;

    listItems.push({ id: config.id, label: config.label, icon: config.icon, key: config.key });

    if (adminModalDueForNotification(wasShown, config.recurrence_days)) {
      pendingCount += 1;
    }
  });

  var $list = $('#notificationModal .notification-list');
  var $empty = $('#notificationModal .notification-empty');
  var $count = $('.notification-count');

  $list.empty();
  listItems.forEach(function (item) {
    var $item = $('<button type="button" class="notification-item d-flex align-items-center py-2 no-freeze" data-modal-id="' + item.id + '" data-storage-key="' + (item.key || '') + '">')
      .append($('<i class="fas ' + item.icon + ' text-muted mr-2" style="width: 1.25rem;"></i>'))
      .append($('<span></span>').text(item.label));
    $list.append($item);
  });

  $count.text(pendingCount);

  if (listItems.length > 0) {
    $empty.addClass('d-none');
  } else {
    $empty.removeClass('d-none');
  }
}

var modalOpenedFromNotifications = null;

$(document).ready(function () {
  buildNotificationList();

  $(document).on('click', '.notification-item', function (e) {
    e.preventDefault();
    var modalId = $(this).data('modal-id');
    var storageKey = $(this).data('storage-key');
    var $modal = $('#' + modalId);
    if ($modal.length) {
      if (storageKey) {
        var today = new Date().toLocaleDateString('pt-BR', {
          timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
        }).split('/').reverse().join('-');
        localStorage.setItem(storageKey, today);
      } else {
        var config = getNotificationModalsConfig().find(function (c) { return c.id === modalId; });
        if (config && config.key) {
          var today = new Date().toLocaleDateString('pt-BR', {
            timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit', day: '2-digit'
          }).split('/').reverse().join('-');
          localStorage.setItem(config.key, today);
        }
      }
      modalOpenedFromNotifications = modalId;
      document.body.classList.add('modal-open');
      $('#notificationModal').modal('hide');
      $('#navbarModal').modal('hide');
      $modal.modal('show');
    }
  });

  // Atualizar lista quando modais forem fechados (usuário pode ter visto um novo)
  $(document).on('hidden.bs.modal', '.modal', function () {
    buildNotificationList();

    // Se fechou um modal que foi aberto a partir das notificações, voltar para a lista
    var closedModalId = $(this).attr('id');
    if (modalOpenedFromNotifications === closedModalId) {
      modalOpenedFromNotifications = null;
      // Manter modal-open e mostrar imediatamente para evitar piscada (blur/overlay)
      document.body.classList.add('modal-open');
      $('#notificationModal').modal('show');
    }
  });
});

// FIX ANCHOR
$(document).on('click', 'a[href*="#"]:not(.no-anchor):not([data-toggle="modal"])', function (event) {
  event.preventDefault();
  event.stopPropagation();

  var href = $(this).attr('href');
  var currentUrl = window.location.href.split('#')[0];
  var targetUrl = href.split('#')[0];

  if (currentUrl !== targetUrl) {
    window.location.href = href;
  } else {
    var anchor = href.split('#')[1];

    if (anchor) {
      var targetElement = $('#' + anchor);

      if (targetElement.length) {
        $('.modal.show').modal('hide');
        $('html, body').animate({
          scrollTop: targetElement.offset().top
        }, 500);
      }
    }
  }

  return false;
});

function setupAutocomplete(inputSelector, listSelector) {
  // Adjust the width of the autocomplete list to match the parent element's width
  const adjustWidth = () => {
    const inputWidth = $(inputSelector).outerWidth() - 26;  // Get width of the input element including padding and border

    $(listSelector).width(inputWidth);  // Set the width of the autocomplete list
  };

  // Filter and display list items based on the input
  const filterAndShowItems = (inputVal) => {
    let hasVisibleItems = false;

    $(`${listSelector} .list-group-item`).each(function() {
      const text = $(this).text().toLowerCase();

      if (text.startsWith(inputVal)) {
        $(this).show();
        hasVisibleItems = true;
      } else {
        $(this).hide();
      }
    });

    // Show or hide the list based on the visibility of items
    $(listSelector).toggle(hasVisibleItems);
  };

  // Handle input event
  $(inputSelector).on('input', function() {
    const inputVal = $(this).val().toLowerCase();

    filterAndShowItems(inputVal);
  });

  // Handle focus event to adjust width and show all items if the input is empty
  $(inputSelector).on('focus', () => {
    adjustWidth();

    if (!$(inputSelector).val().trim()) {
      $(`${listSelector} .list-group-item`).show();
      $(listSelector).show();
    } else {
      filterAndShowItems($(inputSelector).val().toLowerCase());
    }
  });

  // Handle blur event to hide the list with a delay
  $(inputSelector).on('blur', () => {
    setTimeout(() => {
      $(listSelector).hide();
    }, 200);
  });

  // Handle click event on list items to select the value
  $(document).on('click', `${listSelector} .list-group-item`, function() {
    $(inputSelector).val($(this).text()).blur();
  });

  // Adjust the list width when the window is resized
  $(window).resize(adjustWidth);
}

$(document).on('click', "a[data-toggle='tooltip'], button[data-toggle='tooltip']", function() {
  var currentTitle = $(this).attr('data-original-title');
  var alternateTitle = $(this).data('alt-title');

  if (alternateTitle) {
    if (currentTitle !== alternateTitle) {
      $(this).attr('data-original-title', alternateTitle);
      $(this).data('alt-title', currentTitle);

      $(this).tooltip('hide').tooltip('dispose');
      $(this).tooltip();

      $(this).tooltip('show');
    } else {
      $(this).tooltip('hide');
    }
  } else {
    $(this).tooltip('hide');
  }
});

$('html').fadeIn();

window.updateFileCount = function (input) {
  let count = input.files.length;
  let $fileCount = $(input).parents('.form-group').find(".file-count");

  if (count > 0) {
    $fileCount.text(count).removeClass("d-none").addClass("d-inline-block");
  } else {
    $fileCount.addClass("d-none").removeClass("d-inline-block");
  }
}

window.showFreeze = function (_timer, callback) {
  if ($('body').hasClass('loading-content')) {
    return;
  }

  $('body').addClass('loading-content');

  if (!$('.freeze').length) {
    $('body').append('<div class="freeze"><div class="spinner-border text-primary" role="status"><span class="sr-only">Loading...</span></div></div>');
  }

  $('.freeze').removeAttr('style');

  if (arguments.length > 0 && _timer != null && _timer !== false) {
    // Com timer: para troca de abas (tabs) etc
    var timer = _timer || 5000;
    setTimeout(function () {
      if (typeof callback === 'function') {
        callback();
      }
      hideFreeze();
    }, timer);
  }
  // Sem timer: para navegação (links/forms) — freeze fica até o page unload
};

var hideFreeze = function () {
  if ($('.freeze').length) {
    $('.freeze').fadeOut();
  }

  $('body').removeClass('loading-content');
};

setTimeout(() => {
  hideFreeze();
});

function cleanupModalState() {
  if ($('.modal.show').length === 0 && !$('.modal-backdrop').length) {
    document.body.classList.remove('modal-open');
    $('.modal-backdrop').remove(); // remove backdrops órfãos
  }
}

$(window).on('load', function() {
  sessionStorage.removeItem('navigating');
  hideFreeze();
  cleanupModalState();
});

$(window).on('pageshow', function(event) {
  if (event.persisted) {
    // bfcache (ex: voltar com botão Back no Safari) — remover freeze e limpar estado
    sessionStorage.removeItem('navigating');
    hideFreeze();
    cleanupModalState();
  }
});

$('body').on('click', 'a', function (event) {
  var $link = $(this);
  var hasHref = $link.attr('href');
  var hasTarget = $link.attr('target');
  var hasDataConfirm = $link.data().hasOwnProperty('confirm');
  var newTab = event.ctrlKey || event.shiftKey || event.metaKey || (event.button && event.button == 1);
  var isSocialButton = $link.closest('.social-button').length > 0;
  var isCollapseToggle = $link.attr('data-toggle') === 'collapse';
  var isTabToggle = $link.attr('data-toggle') === 'tab';
  var isChatShow = $link.attr('data-show') === '#chat';
  var isModalToggle = $link.attr('data-toggle') === 'modal';
  var isNoFreeze = $link.hasClass('no-freeze');

  var tempLink = document.createElement('a');
  tempLink.href = hasHref;

  var isSamePageAnchor = tempLink.hash && tempLink.pathname === window.location.pathname;

  if (
    hasHref &&
    hasHref !== '' &&
    !isSamePageAnchor &&
    !hasHref.includes('mailto:') &&
    !hasTarget &&
    !hasDataConfirm &&
    !newTab &&
    !isSocialButton &&
    !isCollapseToggle &&
    !isTabToggle &&
    !isChatShow &&
    !isModalToggle &&
    !isNoFreeze
  ) {
    sessionStorage.setItem('navigating', '1');
    window.showFreeze();
  }
});

$('form').on('submit', function (event) {
  var submitter = event.originalEvent?.submitter;
  var $form = $(this);

  // Não mostrar freeze se o form tem a classe 'no-freeze'
  if ($form.hasClass('no-freeze')) {
    return;
  }

  if (!submitter || !$(submitter).hasClass('btn-cancel')) {
    sessionStorage.setItem('navigating', '1');
    window.showFreeze();
  }
});

var modalReturnStack = [];
var swappingModals = false;

function setSwappingModals(value) {
  swappingModals = value;
  window.__helpcamSwappingModals = value;
}

$(document).on('show.bs.modal', '.modal', function (event) {
  if (swappingModals) return;

  var $incoming = $(event.target);
  var $openModal = $('.modal.show').not($incoming);

  if (!$openModal.length) return;

  var openId = $openModal.attr('id');
  if (openId && openId !== $incoming.attr('id')) {
    modalReturnStack.push(openId);
  }

  setSwappingModals(true);
  $openModal.one('hidden.bs.modal', function () {
    document.body.classList.add('modal-open');
    $incoming.one('shown.bs.modal', function () {
      setSwappingModals(false);
    });
    $incoming.modal('show');
  });
  $openModal.modal('hide');

  return false;
});

// Garantir que body tenha modal-open quando qualquer modal estiver visível (para blur funcionar)
$(document).on('show.bs.modal', '.modal', function () {
  document.body.classList.add('modal-open');
});
$(document).on('shown.bs.modal', '.modal', function () {
  document.body.classList.add('modal-open');
});
$(document).on('hidden.bs.modal', '.modal', function () {
  if (swappingModals) return;

  var prevId = modalReturnStack.pop();
  if (prevId) {
    var $prev = $('#' + prevId);
    if ($prev.length) {
      setSwappingModals(true);
      document.body.classList.add('modal-open');
      $prev.one('shown.bs.modal', function () {
        setSwappingModals(false);
      });
      $prev.modal('show');
      return;
    }
  }

  // Defer para evitar remover modal-open durante troca de modal (ex: notificação -> PIX)
  setTimeout(function () {
    if ($('.modal.show').length === 0) {
      document.body.classList.remove('modal-open');
    }
  }, 100);
});

$('.profiles, .accounts').find('video').each(function () {
  var video = this;

  var checkVideoLoaded = function () {
    if (video.readyState >= 2) {
      video.currentTime = 0;
      video.pause();
    } else {
      setTimeout(checkVideoLoaded, 200);
    }
  };

  video.addEventListener('loadeddata', checkVideoLoaded);
  video.load();
});

$(document).ready(function() {
  var isDevelopment = $('body').hasClass('development');

  function isGtagDefined() {
    return typeof gtag !== 'undefined';
  }

  function cleanText(text) {
    return text.replace(/\s+/g, ' ').trim();
  }

  function getFileNameFromSrc(src) {
    return src.substring(src.lastIndexOf('/') + 1);
  }

  $('body').on('click', 'button, input[type="button"], input[type="submit"], a', function(event) {
    var buttonText = $(this).text().trim() || 'No Text';

    if (buttonText === 'No Text') {
      var iconClass = $(this).find('i, span').attr('class') || 'No Icon';
      buttonText = iconClass;
    }

    var linkUrl = $(this).attr('href') || 'No URL';
    var imageSrc = $(this).find('img').attr('src');
    var eventLabel = imageSrc ? getFileNameFromSrc(imageSrc) : cleanText(buttonText);

    var eventData = {
      'event_category': 'Link Button',
      'event_action': 'Click',
      'event_label': eventLabel,
      'transport_type': 'beacon',
      'page_location': linkUrl
    };

    if (!isDevelopment && isGtagDefined()) {
      gtag('event', 'click', eventData);
    }

    if (isDevelopment) {
      console.log('Event Data:', eventData);
    }
  });
});

$(document).ready(function () {
  // --- Modal de código de verificação ---
  if ($('#newRegistrationConfirmationModal').length) {
    $('#newRegistrationConfirmationModal').modal('show');

    const $codeInputs = $('.code-input');

    $codeInputs.on('input', function () {
      if ($(this).val().length === 1) {
        const nextInput = $codeInputs.eq($codeInputs.index(this) + 1);
        if (nextInput.length) nextInput.focus();
      }
    });

    $codeInputs.eq(0).on('paste', function (event) {
      event.preventDefault();
      const pastedCode = event.originalEvent.clipboardData.getData('Text').slice(0, 4);

      $codeInputs.each(function (i) {
        $(this).val(pastedCode[i] || '');
      });

      const firstEmptyInput = $codeInputs.filter(function () {
        return $(this).val() === '';
      }).first();

      if (firstEmptyInput.length) {
        firstEmptyInput.focus();
      } else {
        $codeInputs.last().focus();
      }
    });

    $codeInputs.on('keydown', function (event) {
      if (event.key === "Backspace" && $(this).val().length === 0) {
        const prevInput = $codeInputs.eq($codeInputs.index(this) - 1);
        if (prevInput.length) prevInput.focus();
      }

      if ($codeInputs.filter(function () { return $(this).val() !== ''; }).length === 0) {
        $codeInputs.first().focus();
      }
    });

    $codeInputs.on('focus', function () {
      if (!$(this).val()) {
        $(this).attr('placeholder', '');
      }
    });

    $codeInputs.on('blur', function () {
      if (!$(this).val()) {
        $(this).attr('placeholder', '_');
      }
    });

    $codeInputs.first().focus();
  }

  // --- Cartão de crédito ---
  const $cardBox = $(".box-credit-card");

  const defaultMasked = $cardBox.data("default-number") || "**** **** **** ****";
  const defaultBrand = $cardBox.data("default-brand") || "Cartão";
  const defaultIcon = $cardBox.data("default-icon") || "fab fa-credit-card";

  $("#cardNumber").on("input", function () {
    let rawInput = $(this).val();
    let digits = rawInput.replace(/\D/g, "");

    updateCardNumber(rawInput);
    updateCardBrand(digits);
  });

  $("#cardNumber").on("blur", function () {
    let cardNumber = $(this).val().replace(/\D/g, "");

    if (cardNumber.length < 16) {
      $(".card-number").text(defaultMasked);
      $(".chip").attr("class", "chip " + defaultIcon);
      $(".brand").text(defaultBrand);
    }
  });

  $("#cardholderName").on("input", function () {
    let name = $(this).val().toUpperCase();

    updateCardName(name);
  });

  $("#cardExpirationMonth, #cardExpirationYear").on("change", function () {
    let month = $("#cardExpirationMonth").val();
    let year = $("#cardExpirationYear").val().slice(-2);

    updateExpiration(month, year);
  });

  function updateCardNumber(rawInput) {
    const digits = rawInput.replace(/\D/g, "");
    const totalDigits = digits.length;

    if (totalDigits < 13) {
      $(".card-number").text("**** **** **** ****");
      return;
    }

    let revealedDigits = digits.slice(12).padEnd(4, "*");

    $(".card-number").text(`**** **** **** ${revealedDigits}`);
  }

  function updateCardBrand(cardNumber) {
    let detectedBrandClass = "fab fa-credit-card";
    let detectedBrandText = "Cartão";

    if (/^4/.test(cardNumber)) {
      detectedBrandClass = "fab fa-cc-visa";
      detectedBrandText = "VISA";
    } else if (/^5[1-5]/.test(cardNumber)) {
      detectedBrandClass = "fab fa-cc-mastercard";
      detectedBrandText = "MASTERCARD";
    } else if (/^3[47]/.test(cardNumber)) {
      detectedBrandClass = "fab fa-cc-amex";
      detectedBrandText = "AMEX";
    } else if (/^6(?:011|5)/.test(cardNumber)) {
      detectedBrandClass = "fab fa-cc-discover";
      detectedBrandText = "DISCOVER";
    } else if (/^(?:2131|1800|35\d{3})/.test(cardNumber)) {
      detectedBrandClass = "fab fa-cc-jcb";
      detectedBrandText = "JCB";
    }

    const $chip = $(".chip");

    if (!$chip.hasClass(detectedBrandClass)) {
      $chip.attr("class", "chip " + detectedBrandClass);
      $(".brand").text(detectedBrandText);
    }
  }

  function updateCardName(name) {
    if (name.trim() === "") {
      name = "NOME DO TITULAR";
    }
    $(".card-holder div").text(name);
  }

  function updateExpiration(month, year) {
    if (!month) month = "MM";
    if (!year) year = "YY";
    $(".expiration div").text(`${month}/${year}`);
  }
});

$(document).ready(function () {
  function autoResize($textarea) {
    const minHeight = $textarea.data('min-height') || $textarea.outerHeight();
    $textarea.data('min-height', minHeight);

    $textarea.css('height', 'auto');
    const newHeight = Math.max($textarea.prop('scrollHeight'), minHeight);
    $textarea.css('height', newHeight + 'px');
  }

  $(document).on('input', 'textarea', function () {
    autoResize($(this));
  });

  $('#toggleTextarea').on('click', function () {
    $('#textareaContainer').show();

    setTimeout(function () {
      $('#textareaContainer textarea').each(function () {
        autoResize($(this));
      });
    }, 0);
  });
});

$(document).ready(function () {
  const $modal = $('#securityCodeModal');
  if ($modal.length === 0) return;

  const balance = parseFloat($modal.data('balance')) || 0.0;
  const hasCreditCard = $modal.data('hasCreditCard') === true;

  // console.log('balance', balance)
  // console.log('hasCreditCard', hasCreditCard)

  const $select = $('#conference_total_time_in_minutes');
  const $cvvSections = $('.cvv-section');

  function updateCVVVisibility() {
    const $selectedOption = $select.find('option:selected');
    const totalPrice = parseFloat($selectedOption.data('price')) || 0.0;

    // console.log('totalPrice', totalPrice)
    // console.log('balance condition', (balance === 0 && hasCreditCard))

    if (balance > 0) {
      // Saldo cobre o pacote inteiro (inclui totalPrice === balance); senão exige CVV/cartão.
      if (totalPrice > balance) {
        $cvvSections.removeClass('hide-cvv');
        $cvvSections.find(':input').attr('disabled', false);
      } else {
        $cvvSections.addClass('hide-cvv');
        $cvvSections.find(':input').attr('disabled', true);
      }
    } else {
      if (hasCreditCard) {
        $cvvSections.removeClass('hide-cvv');
        $cvvSections.find(':input').attr('disabled', false);
      }
    }
  }

  updateCVVVisibility();
  $select.on('change', updateCVVVisibility);
});

$(document).on('change', 'input[type="file"]', function () {
  const $input = $(this);
  const $container = $input.closest('.file-container');
  const $fileListContainer = $container.find('.selected-files');

  $fileListContainer.html('');

  const files = Array.from(this.files);

  files.forEach((file, index) => {
    const isVideo = file.type.startsWith('video/');
    const videoUrl = isVideo ? URL.createObjectURL(file) : null;

    const fileItem = $(`
      <div class="mb-2">
        ${isVideo ? `<video src="${videoUrl}" controls width="300" class="d-block mb-1"></video>` : ''}
        <span>${file.name}</span>
        (<a href="#" class="remove-file no-freeze no-anchor" data-index="${index}">Remover</a>)
      </div>
    `);

    $fileListContainer.append(fileItem);
  });

  $input.data('files', files);
});

$(document).on('click', '.remove-file', function (e) {
  e.preventDefault();
  e.stopPropagation();

  const $removeButton = $(this);
  const indexToRemove = parseInt($removeButton.data('index'));

  const $container = $removeButton.closest('.file-container');
  const $input = $container.find('input[type="file"]');
  const $fileListContainer = $container.find('.selected-files');

  let files = $input.data('files') || Array.from($input[0].files);

  files.splice(indexToRemove, 1);

  const dataTransfer = new DataTransfer();
  files.forEach(file => dataTransfer.items.add(file));

  $input[0].files = dataTransfer.files;
  $input.data('files', files);

  $fileListContainer.html('');

  files.forEach((file, index) => {
    const isVideo = file.type.startsWith('video/');
    const videoUrl = isVideo ? URL.createObjectURL(file) : null;

    const fileItem = $(`
      <div class="mb-2">
        ${isVideo ? `<video src="${videoUrl}" controls width="300" class="d-block mb-1"></video>` : ''}
        <span>${file.name}</span>
        (<a href="#" class="remove-file no-freeze" data-index="${index}">Remover</a>)
      </div>
    `);

    $fileListContainer.append(fileItem);
  });
});

// Modal PIX movido para o bloco unificado de modais automáticos (acima)

// --- User Type Survey Modal ---
$(document).ready(function() {
  var isDevelopment = $('body').hasClass('development');

  function isGtagDefined() {
    return typeof gtag !== 'undefined';
  }

  function showUserTypeSurveyModal() {
    $('#userTypeSurveyModal').modal('show');
  }

  function hideUserTypeSurveyModal() {
    localStorage.setItem('userTypeSurveyCompleted', 'true');
    localStorage.setItem('userTypeSurveyCompletedAt', new Date().toISOString());
    $('#userTypeSurveyModal').modal('hide');
  }

  function sendUserTypeAnalytics(userType, action = 'survey_response') {
    var eventData = {
      'event_category': 'User Type Survey',
      'event_action': action,
      'event_label': userType,
      'transport_type': 'beacon',
      'custom_map': {
        'user_type_preference': userType
      }
    };

    // Enviar para Google Analytics
    if (!isDevelopment && isGtagDefined()) {
      gtag('event', 'user_type_survey', eventData);

      // Também definir como propriedade customizada do usuário
      gtag('config', 'G-V2LTESKN78', {
        'custom_map': {
          'user_type_preference': userType
        }
      });
    }

    if (isDevelopment) {
      console.log('User Type Survey Event:', eventData);
    }
  }

  function initializeUserTypeSurvey() {
    var isLoggedIn = $('body').data('user-slug') && $('body').data('user-slug') !== '';
    var surveyCompleted = localStorage.getItem('userTypeSurveyCompleted');
    var completedAt = localStorage.getItem('userTypeSurveyCompletedAt');

    // Se já respondeu há menos de 30 dias, não mostrar novamente
    if (surveyCompleted === 'true' && completedAt) {
      var completedDate = new Date(completedAt);
      var thirtyDaysAgo = new Date();
      thirtyDaysAgo.setDate(thirtyDaysAgo.getDate() - 30);

      if (completedDate > thirtyDaysAgo) {
        return;
      }
    }

    // Mostrar modal após 3 segundos em qualquer página
    setTimeout(function() {
      showUserTypeSurveyModal();
    }, 3000);
  }

  // Handlers para as opções da pesquisa
  $('#userTypeSurveyModal .survey-option').on('click', function() {
    var userType = $(this).data('user-type');

    // Armazenar resposta
    localStorage.setItem('userTypePreference', userType);
    localStorage.setItem('userTypePreferenceDate', new Date().toISOString());

    // Enviar para analytics
    sendUserTypeAnalytics(userType, 'selected');

    // Fechar modal
    hideUserTypeSurveyModal();

    // Mostrar mensagem de agradecimento (opcional)
    if (userType === 'cliente') {
      // Poderia destacar seção de profissionais ou mostrar toast
    } else if (userType === 'profissional') {
      // Poderia destacar como se cadastrar como profissional
    }
  });

  // Handler para pular pesquisa
  $('#skipSurveyBtn, #skipSurveyBtn2').on('click', function() {
    sendUserTypeAnalytics('skipped', 'skipped');
    hideUserTypeSurveyModal();
  });

  // Handler para fechar modal com ESC (mesmo sendo backdrop static)
  $(document).on('keydown', function(e) {
    if (e.keyCode === 27 && $('#userTypeSurveyModal').hasClass('show')) {
      sendUserTypeAnalytics('escaped', 'escaped');
      hideUserTypeSurveyModal();
    }
  });

  // Inicializar pesquisa
  initializeUserTypeSurvey();
});

// Sistema de Favoritos - Com form mas AJAX direto
$(document).on('click', '.favorite-btn', function(e) {
  e.preventDefault();
  e.stopPropagation();

  const $btn = $(this);
  const $form = $btn.closest('form');
  const url = $form.attr('action');

  // Fazer AJAX usando os dados do form
  $.ajax({
    url: url,
    method: 'PATCH',
    dataType: 'json',
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    },
    success: function(data) {
      // Atualizar visual baseado na resposta
      if (data.favorited) {
        $btn.addClass('favorited');
        $btn.removeClass('unfavorited');
      } else {
        $btn.removeClass('favorited');
        $btn.addClass('unfavorited');
      }
    },
    error: function() {
      alert('Erro ao processar favorito.');
    }
  });

  return false;
});
